import React from 'react'

import { motion } from 'framer-motion';
import { containerVariants, itemVariants, textVariants, container, child, imageVariants } from '../script/animation';


const Detail = ({ blog, id1 }) => {


  console.log(blog)


  return (
    <motion.div className="w-full bg-red grid grid-cols-11 relative  py-20  calc-height content-start">




      <motion.div variants={containerVariants}
        initial="hidden"
        animate="visible" className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-8 z-50   mb-5 ">
        <motion.h2 variants={textVariants} className='font-bold text-30 text-genesisBlue'>{blog?.title}</motion.h2>
      </motion.div>




      <motion.div variants={containerVariants}
        initial="hidden"
        animate="visible" className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-8 z-50 pb-5  grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-3">
        {
          blog?.images?.map((item, index) => {
            console.log(item)
            return (
              <div className='overflow-hidden'>
              <motion.img variants={imageVariants} src={`/images/sirket-haberleri/${id1}/${item}.jpg`} />
              </div>
            )
          })
        }
      </motion.div>



      <motion.div variants={containerVariants}
        initial="hidden"
        animate="visible" className='col-start-2 col-span-9 lg:col-start-2 lg:col-span-8 space-y-5'>
        {
          blog?.text?.map((item, index) => {
            return (
              <motion.p variants={textVariants} className='text-18 text-customGray'>{item}</motion.p>
            )
          })
        }

      </motion.div>






    </motion.div>
  )
}

export default Detail